import { Component, OnInit, ViewEncapsulation, EventEmitter, Output } from '@angular/core';
import {
    trigger,
    state,
    style,
    animate,
    transition
  } from '@angular/animations';
import { Observable } from 'rxjs';


@Component({
  selector: 'ngxui-sidenav',
  templateUrl: './sidenav.component.html',
  styleUrls: ['./sidenav.component.scss'],
  encapsulation: ViewEncapsulation.None,
  animations: [
    trigger('OpenFullState', [
        state('open', style({
            width: '100%'
        })),
        state('closed',   style({
            width: '0'
        })),
        transition('closed => open', animate('200ms ease-in')),
        transition('open => closed', animate('100ms ease-out'))
    ]),
  ]
})
export class SidenavComponent implements OnInit {
    collapse:string = "closed";

    @Output() DismissEvent: EventEmitter<any> = new EventEmitter<any>();
    @Output() CloseEvent: EventEmitter<any> = new EventEmitter<any>();
    constructor() { }

    ngOnInit() {
    }

    openNav() {
        this.collapse = this.collapse === 'open' ? 'closed' : 'open';
    }

    dismissNav(event) {
        try {
            event.preventDefault();
        } catch (ex) {}
        this.collapse = this.collapse === 'open' ? 'closed' : 'open';
        this.DismissEvent.emit(event);
    }

    closeNav(event) {
        event.preventDefault();
        this.collapse = this.collapse === 'open' ? 'closed' : 'open';
        this.CloseEvent.emit(null);
    }
}
